import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { BomMatcher } from '../bom-matcher'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ElderLabelInputComponent } from '@elderbyte/ngx-starter'
import { MaterialMatcherDetailComponent } from '../material-matcher-detail/material-matcher-detail.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-bom-matcher-detail',
  templateUrl: './bom-matcher-detail.component.html',
  styleUrls: ['./bom-matcher-detail.component.scss'],
  imports: [
    MaterialMatcherDetailComponent,
    ElderLabelInputComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class BomMatcherDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _matcher$ = new BehaviorSubject<BomMatcher>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set matcher(matcher: BomMatcher) {
    this._matcher$.next(matcher)
  }

  public get matcher$(): Observable<BomMatcher> {
    return this._matcher$.asObservable()
  }
}
